module.exports = __webpack_public_path__ + "static/media/Grasmaaier.9f51adcb.mp3";